import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-enable-swift-preference-pop-up',
  templateUrl: './enable-swift-preference-pop-up.component.html',
  styleUrls: ['./enable-swift-preference-pop-up.component.css']
})
export class EnableSwiftPreferencePopUpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EnableSwiftPreferencePopUpComponent>) { }

  ngOnInit(): void {
  }

}
